import React from "react";
import { connect } from "react-redux";
import FormularioSeguridad from "../gnp-registro-seguridad/formulario-seguridad.cmpt";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import { reduxForm } from "redux-form";
import "./registro-express.css";
import { callService, goTo } from "../tools";
import axios from 'axios';
import MediosElectronicos from "../gnp-registro/mediosElectronicos.cmpt";
import Checkbox from 'material-ui/Checkbox';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { validarPass } from "../gnp-login/services.act";
import { authentication } from "../app-database";
import { servicios } from "../properties";

const errorDisculpe = "Error Disculpe, ocurrió un error en el servicio, favor de realizar su registro nuevamente.";
const aplication = 'application/json';
const avisoTxt = "Grupo Nacional Provincial, S.A.B., con domicilio en Avenida Cerro de las Torres No. 395, " +
	"Colonia Campestre Churubusco, Código Postal 04200, Alcaldía Coyoacán, Ciudad de México, " +
	"tratará sus datos personales, patrimoniales e incluso sensibles para evaluar su solicitud de seguro  " +
	"y en caso de ser aceptada brindarle los servicios relacionados con su contrato de seguro. Puede " +
	"consultar la versión integral del Aviso de Privacidad en la página www.gnp.com.mx";
const avisoTxt2 = "Al hacer clic en “CONTINUAR” reconozco que previo al tratamiento y a proporcionar mis datos " +
	"personales se ha puesto a mi disposición el Aviso de Privacidad Integral de Grupo Nacional " +
	"Provincial, S.A.B. (en lo sucesivo GNP), el cual he leído y comprendido, por lo que tengo " +
	"conocimiento de (i) la identidad y domicilio de GNP; (ii) los datos personales que serán sujetos " +
	"a tratamiento; (iii) las finalidades primarias y secundarias del tratamiento, así como las " +
	"transferencias que van a efectuarse; (iv) los medios habilitados para limitar el uso o divulgación " +
	"de mis datos personales y/o revocar mi consentimiento, así como para ejercer mis derechos de acceso, " +
	"rectificación, cancelación y oposición. Asimismo manifiesto tener conocimiento que puedo consultar el " +
	"Aviso de Privacidad Integral y sus actualizaciones en cualquier momento en la página www.gnp.com.mx";
const avisoTxt3 = "En caso de haber proporcionado datos personales de otros titulares, reconozco haber cumplido con mi obligación " +
	"de informarles sobre su entrega, haber obtenido de forma previa el consentimiento de éstos para su tratamiento, " +
	"así como haberles informado los lugares en los que se encuentra disponible el Aviso de Privacidad Integral para su consulta.";

const titulo_aviso = "AVISO DE PRIVACIDAD INTEGRAL";
const msg_aviso = "Conozco y entiendo que mis datos son tratados conforme al Aviso de privacidad Integral";
const txt_1 = "He leído y acepto los";
const txt_2 = "Términos y condiciones de uso de Medios Electrónicos";
const txt_3 = "de Grupo Nacional Provincial S.A.B";
const txt_boton = "Continuar";
const validacion = "VALIDACIÓN";
const mensajeItim = "Ocurrió un error inesperado, comunícate a la línea GNP 55 5227 9000 para más información.";

const mapState = (state) => {
	return {
		dispositivo: state.global.dispositivo,
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		regresar: (disp) => {
			dispatch({ "type": "EVENT_REGISTRO_DP-REGRESAR", "dispositivo": disp });
		},
		avisoPrivacidad: (showAviso) => {
			dispatch({ "type": "AVISO_PRIVACIDAD", "showAviso": showAviso });
		},
		avisoTerminos: (showAviso) => {
			dispatch({ "type": "AVISO_TERMINOS", "showAviso": showAviso });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		},
		loginSecreto: (nombre) => {
			dispatch({ "type": "LOGIN_SET_SECRETO", "secreto": nombre });
		},
		loginserCliente: (clienteUnico) => {
			dispatch({ "type": "LOGIN_SET_CVECLIENTE", "cveCliente": clienteUnico });
		},
		eventoCorrectos: (dispositivo) => {
			dispatch({ "type": "EVENT_LOGIN_BIENVENIDO_CORRECTOS", "flujo": "login", "dispositivo": dispositivo });
		},
		loginIniciarSesionCorrecto: (dispositivo) => {
			dispatch({ "type": "EVENT_LOGIN_INICIARSESION_CORRECTOS", "flujo": "login", "dispositivo": dispositivo });
		}
	};
}

class FormularioRegistroExpress extends React.Component {

	pass1 = "";
	nombre = "";
	hashOne = "";
	hashTwo = "";
	hashThree = "";
	password = "";
	contador = 0;
	URLBienvenido = "login.bienvenido";
	state = {
		avisoAceptado: false,
		mediosElectronicos: false,
		habilitaBtnAviso: true,
		nombreCompleto: "",
		celular: "",
		email: "",
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
	}

	componentDidMount = () => {
		if (this.contador === 0) {
			localStorage.removeItem("aceptarAvisoPrivacidad");
			localStorage.removeItem("aceptarMediosElectronicos");
			this.contador = this.contador + 1;
		}

		const hash = localStorage.getItem("hashOne");
		this.hash1 = atob(hash);
		this.consultaDatos();
	}

	consultaDatos = () => {
		this.props.loader(true);

		new callService({
			service: 'registro.obtenerNombreMedios',
			"secure": true,
			data: { cveCliente: this.hash1 }
		}).execute().then(body => {

			this.setState({ nombreCompleto: body.nombre + " " + body.apellidoPaterno });
			this.setState({ celular: body.telefono });
			this.setState({ email: body.correo });
			this.obtenerHashReverse();

			setTimeout(() => {
				this.props.loader(false);
			}, 3000);

		}).catch(error => {
			console.log('error', error);
			this.props.loader(false);
		});
	}

	obtenerHashReverse = () => {
		const servicio = "registro.obtenerurlregistro";

		new callService({
			service: servicio,
			secure: false,
			data: { valor: this.hash1 }
		}).execute().then(resp1 => {

			this.hashOne = resp1.hash;

			new callService({
				service: servicio,
				secure: false,
				data: { valor: this.state.email }
			}).execute().then(resp2 => {

				this.hashTwo = resp2.hash;

				new callService({
					service: servicio,
					secure: false,
					data: { valor: this.state.celular }
				}).execute().then(resp3 => {

					this.hashThree = resp3.hash;

				}).catch(error => {
					console.log("erroxr", error);
				});

			}).catch(error => {
				console.log("Error", error);
			});

		}).catch(error => {
			console.log("ERROR", error);
		});
	}

	irLogin = () => {
		this.props.loader(true);
		axios({
			method: 'POST',
			url: servicios.utilerias.actualizaNodoRestablecer,
			headers: {
				'Content-Type': aplication,
				'Access-Control-Allow-Origin': '*',
				"valor": this.state.email,
				"encripta": true
			}
		}).then(response => {
			const encriptar = true;
			new callService({
				"service": this.URLBienvenido,
				"secure": true,
				"data": { "correo": response.data.hash, "encriptar": encriptar }
			}).execute().then(body => {
				if (body.hasOwnProperty("consultarClienteResponse")) {

					localStorage.removeItem("aceptarAvisoPrivacidad");
					localStorage.removeItem("aceptarMediosElectronicos");

					this.props.loginSecreto(body.consultarClienteResponse.nombre);
					this.props.loginserCliente(localStorage.getItem('cveClienteUnico'));
					this.props.loginIniciarSesionCorrecto(this.props.dispositivo);
					this.mandaPassword(this.hash1, this.state.email, this.pass1);
				} else {
					console.log('error');
					goTo("login");
				}
			}).catch(error => {
				console.log(error);
				goTo("login");
				this.props.loader(false);
			})
		}).catch(error => {
			console.log("errores", error);
		});
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

	cierraTooltip = () => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

	validarCampoPass = () => {
		const pass1 = document.getElementsByName('password')[0].value;
		const pass2 = document.getElementsByName('confpassword')[0].value;

		if (pass1 === "" || pass2 === "") {
			console.log("");
		} else {
			this.submit(pass1);
		}
	}

	submit = (pass) => {
		this.props.loader(true);
		this.pass1 = pass;

		new callService({
			service: "registro.datosContratos",
			secure: true,
			data: {
				pregunta1: "PSC15",
				pregunta2: "PSC04",
				password: pass,
				respuesta1: "negro",
				respuesta2: "nissan",
				hashOne: this.hashOne,
				hashTwo: this.hashTwo,
				mediosElectronicos: true,
				avisoPrivacidad: true,
				email: this.state.email,
				hashCel: this.hashThree
			}
		}).execute().then((respuesta) => {
			console.log("respuesta", respuesta);
			this.validarUsuarioCompleto(this.state.email, false);
			this.registroBorradoUsuarios2();
			this.props.loader(true);
		}).catch((error) => {
			console.log("Error service", error);

			this.props.tagManager({
				"type": "EVENT_REGISTRO_EXPRESS_SIG_INCORRECTOS", "dispositivo": this.props.dispositivo
			});

			setTimeout(() => {
				this.props.loader(false);
			}, 2000);

			setTimeout(() => {
				if (error.message.codigoError.includes("ITIM")) {
					this.muestraTooltip(true, 'error', validacion, mensajeItim);
				} else if (error.message.codigoError === 'eCl00026') {
					this.muestraTooltip(true, 'error', 'ERROR', "Lo sentimos, por su seguridad no puede introducir contraseñas anteriores.");
				} else if (error.message.codigoError.includes("ERROR")) {
					this.muestraTooltip(true, 'error', validacion, error.message.mensaje.substring(2));
				}
				else {
					this.validarUsuarioCompleto(this.state.email, false);
				}
			}, 1000);

			setTimeout(() => {
				this.muestraTooltip(false);
			}, 5000);
		})

	}

	exitoDatosContratos = () => {
		this.props.loader(false);
		this.props.tagManager({
			"type": "EVENT_REGISTRO_EXPRESS_SIG_CORRECTOS", "dispositivo": this.props.dispositivo, "ramo": localStorage.getItem("ramo")
		});
		$('#modal-final-bienvenida').modal({ backdrop: 'static', keyboard: false });
	}

	validarUsuarioCompleto = (correo, exito) => {
		axios({
			method: 'POST',
			url: servicios.utilerias.actualizaNodoRestablecer,
			headers: {
				'Content-Type': aplication,
				'Access-Control-Allow-Origin': '*',
				"valor": correo,
				"encripta": true
			}
		}).then(response => {
			const encriptar = true;
			new callService({
				"service": this.URLBienvenido,
				"secure": true,
				"data": { "correo": response.data.hash, "encriptar": encriptar }
			}).execute().then(body => {
				if (body.hasOwnProperty("consultarClienteResponse")) {
					this.nombre = body.consultarClienteResponse.nombre;
					this.exitoDatosContratos(correo);
				} else {
					exito ? console.log('ocurrio un error ene l exito') : this.muestraTooltip(true, 'error', 'ERROR', errorDisculpe);
				}
			}).catch(error => {
				exito ? console.log('ocurrio un error ene l exito') : this.muestraTooltip(true, 'error', 'ERROR', errorDisculpe);
				this.props.loader(false);
			})
		}).catch(error => {
			console.log("error", error);
		});
	}

	mandaPassword = (cliente, correo, pass) => {
		validarPass(cliente, correo, pass).then((response) => response.json()).then((responseJson) => {

			if (responseJson.hasOwnProperty("jwt")) {
				authentication.signInWithCustomToken(responseJson.jwt).then(function () {
					this.props.eventoCorrectos(this.props.dispositivo);
					localStorage.setItem("refreshToken", responseJson.refreshtoken);
					window.location.assign(servicios.dominioReingenieria + "principal/home");
					this.props.tagManager({
						"type": "EVENT_LOGIN_INICIAR_SESION", "dispositivo": this.props.dispositivo
					});
					this.props.loader(false);
				}).catch(function (error) {
					console.log("Error", error);
					window.location.assign(servicios.dominioReingenieria);
					this.props.loader(false);
				});
			} else {
				console.log('error');
				window.location.assign(servicios.dominioReingenieria);
				this.props.loader(false);
			}
		})
	}

	showModal = () => {
		$("#modal-terminos-condiciones").modal({ backdrop: "static", keyboard: false });
	}

	checkAvisoTerminos = () => {
		console.log("Estado del checkbox Medios: " + mediosElectronicos.checked);
		this.habilitaBotonPrivacidad();
	}

	habilitaBotonPrivacidad = () => {
		if (aceptarAviso.checked === false || mediosElectronicos.checked === false) {
			this.setState({ "habilitaBtnAviso": true });
		} else {
			this.setState({ "habilitaBtnAviso": false });
		}
	}

	checkAviso = () => {
		console.log("Estado del checkbox Aviso: " + aceptarAviso.checked);
		this.habilitaBotonPrivacidad();
	}

	aceptarAvisoMedios = () => {
		localStorage.setItem("aceptarAvisoPrivacidad", true);

		this.props.tagManager({ "type": "ACEPTO_MEDIOS_ELECTRONICOS", "dispositivo": this.props.dispositivo });
		this.props.change("mediosElectronicos", true);
		this.setState({ mediosElectronicos: true });

		this.props.tagManager({ "type": "ACEPTO_AVISO_PRIVACIDAD", "dispositivo": this.props.dispositivo });
		this.props.change("avisoAceptado", true);
		this.setState({ avisoAceptado: true });

		localStorage.setItem("aceptarMediosElectronicos", true);

		this.props.avisoPrivacidad(false);
		this.props.avisoTerminos(false);
		this.registroBorradoUsuarios();

		window.scrollTo(0, 0);
	}

	registroBorradoUsuarios = () => {
		console.log("Se guardaran datos en firebase");

		new callService({
			service: "registro.datosBorradoUsuarios",
			secure: false,
			data: {
				ramaClave: this.hash1,
				completo: false,
				confidencialidad: false,
				contrato: false,
				email: this.state.email
			}
		}).execute().then((resp) => {
			console.log("Respuesta datosBorradoUsuarios ", resp);

		}).catch((error) => {
			console.log("Error datosBorradoUsuarios ", error);
		});
	}

	registroBorradoUsuarios2 = () => {
		console.log("Se actualizaran datos en firebase");

		new callService({
			service: "registro.datosBorradoUsuarios",
			secure: false,
			data: {
				ramaClave: this.hash1,
				completo: true,
				confidencialidad: true,
				contrato: true,
				email: this.state.email
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta datosBorradoUsuarios ", respuesta);

		}).catch((error) => {
			console.log("Error datosBorradoUsuarios ", error);
		});
	}

	render() {
		return <div id="container-registro-express" style={{ width: "1200px", marginTop: "50px", marginLeft: "auto", marginRight: "auto" }}>

			<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
				show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
			</ModalSintillo>

			{(localStorage.getItem("aceptarAvisoPrivacidad") !== "true" && localStorage.getItem("aceptarMediosElectronicos") !== "true") &&
				<div id="aviso-rpivacidad" style={{ marginLeft: "10%", marginRight: "10%", marginBottom: "100px" }}>
					<div className="avisoPrivacidad-titulo">
						<p>{titulo_aviso}</p>
					</div>

					<div className="avisoPrivacidad-body">
						<div className="avisoPrivacidad-type-txt">{avisoTxt}</div> <br />
						<div className="avisoPrivacidad-type-txt">{avisoTxt2}</div> <br />
						<div className="avisoPrivacidad-type-txt">{avisoTxt3}</div> <br />
					</div>

					<div className="avisoPrivacidad-footer">
						<div className="content-check">
							<MuiThemeProvider>
								<Checkbox
									iconStyle={{ color: "#0C2040 !important", fill: "#FF6B0B" }}
									id="aceptarAviso" name="aceptarAviso"
									onClick={this.checkAviso}
									value="aviso" onChange={this.checkAviso}
									className="check-aviso"

								/>
							</MuiThemeProvider>
							<p className="avisoPrivacidad-type-txt">{msg_aviso}</p>
						</div>

						<div id="terminosCondiciones" className="margin-top-terminos">
							<MuiThemeProvider>
								<Checkbox
									iconStyle={{ color: "#0C2040 !important", fill: "#FF6B0B" }}
									value="mediosElectronicos" onChange={this.checkAvisoTerminos}
									id="mediosElectronicos" name="mediosElectronicos"
									onClick={this.checkAvisoTerminos}
								/>
							</MuiThemeProvider>
							<div id="terCon" style={{ marginTop: "-24px", position: "absolute" }}>
								<span className="avisoPrivacidad-type-txt" id="terminosCondiciones-1" style={{ marginLeft: "37px" }}>
									{txt_1}</span>
								<span className="avisoPrivacidad-type-txt" id="terminosCondiciones-2" style={{ marginLeft: "-10px" }} onClick={this.showModal}>
									{txt_2}</span>
								<span className="avisoPrivacidad-type-txt" id="terminosCondiciones-3" style={{ marginLeft: "-10px" }}>
									{txt_3}</span><br />
							</div>
						</div>

						<button type="submit" disabled={this.state.habilitaBtnAviso}
							id="btnAceptarAviso" className='orange-rectangle' onClick={this.aceptarAvisoMedios}>
							{txt_boton}
						</button>
					</div>

					<div className="modal fade modal-msj" id="modal-terminos-condiciones"
						tabIndex="-1" role="dialog" aria-labelledby="modal-terminos-condiciones"
						data-backdrop="static" data-keyboard="false">

						<div className="modal-dialog modal-terminos-responsive" role="document">
							<div className="modal-content" id="div-body-modal">
								<MediosElectronicos></MediosElectronicos>
							</div>
						</div>
					</div>
				</div>
			}

			{(localStorage.getItem("aceptarAvisoPrivacidad") === "true" && localStorage.getItem("aceptarMediosElectronicos") === "true") &&
				<div id="form-registro-express">
					<div id="div-bienvenida">
						<label id="msj-bienvenida">¡Bienvenido, {this.state.nombreCompleto}!</label><br />
						<label id="ms-informativo">Por ser parte de GNP ya estás registrado en Portal y App Soy Cliente. Establece tu contraseña:
						</label>

						<div id="datos-reg" style={{ marginTop: "20px", fontWeight: "400" }}>
							<label id="email-reg">Correo registrado: <span style={{ color: "#FF6B0B" }}>{this.state.email}</span></label><br />
							<label id="cel-reg" style={{ position: "absolute", marginTop: "-20px" }}>Teléfono celular:
								<span style={{ color: "#FF6B0B" }}> {this.state.celular}</span>
							</label>
						</div>
					</div>
					<FormularioSeguridad></FormularioSeguridad>

					<button id="btn-continuar-express" onClick={this.validarCampoPass} className="orange-rectangle">
						Continuar
					</button>
				</div>
			}

			<div className='modal fade' id='modal-final-bienvenida' tabIndex='-1' role='dialog' aria-labelledby='modal-final-bienvenida'
				style={{ marginLeft: '19%' }}>

				<span className='icon-circle-dove icono-modal-final' id="icon-bienvenida" />
				<h4 className='modalfin-title' id="msg-bienvenida">
					¡Bienvenido {this.nombre}!
				</h4>

				<div id="msg-body-bienvenida">
					<p id="p-bienvenida">Tu información ha sido guardada satisfactoriamente</p>
					<p id="p-bienvenida">De ahora en adelante podrás iniciar sesión ingresando tu correo y contraseña.
					</p>
				</div>

				<button type='button' className='btn-orange-modal-final' id="btn-bienvenida"
					onClick={this.irLogin.bind(this)} data-dismiss='modal'>Acceder ahora</button>
			</div>
		</div>;
	}
}

FormularioRegistroExpress = reduxForm({ form: "registroExpress" })(FormularioRegistroExpress);
export default connect(mapState, mapDispatch)(FormularioRegistroExpress);


// WEBPACK FOOTER //
// ./src/gnp-registro-express/registro-express.frm.js